module.exports = __webpack_public_path__ + "assets/images/container_phase4.d8c2024b2bb1a47d365af2d385c717b6.svg";